import React from 'react';
import styles from './HomeIntro.module.css';
import Button from '../../components/Button';

const HomeIntro: React.FC = () => {
  return (
    <section className={styles.homeIntroSection}>
      <div className={styles.homeIntroContainer}>
        <div className={styles.homeIntroContent}>
          <h1 className={styles.slideRight}>Built on Craft</h1>
          <h1 className={styles.slideLeft}>Driven by Passion</h1>
          <p className={styles.slideUp} style={{ animationDelay: '0.3s' }}>At LB Tiling, tiling isn't just a trade — it's a craft we take pride in.</p>
          <p className={styles.slideUp} style={{ animationDelay: '0.6s' }}>We're a small team of experienced professionals based right here in Revelstoke, BC, and we specialize in residential and commercial tile installation that's built to last and designed to impress.</p>
          <p className={styles.slideUp} style={{ animationDelay: '0.9s' }}>From custom bathroom renovations to large-scale floors, we bring the same attention to detail, respect for your space, and dedication to quality to every single project.</p>
          <p className={styles.slideUp} style={{ animationDelay: '1.2s' }}>We believe that great work starts with good communication and ends with results that speak for themselves.</p>
          <p className={styles.slideUp} style={{ animationDelay: '1.5s' }}>When you hire LB Tiling, you're not just getting a contractor — you're getting a partner who cares as much about the finished product as you do.</p>
          <div className={styles.slideUp} style={{ animationDelay: '1.8s' }}>
            <Button 
              onClick={() => {
                const contactSection = document.querySelector('#contact');
                contactSection?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Contact Us
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeIntro;